import immer from "immer";

const Reducer = (state, action) => {
  switch (action.type) {
    case "RESERVATION_SET":
      return immer(state, (draft) => {
        draft.reservation = action.payload;
      });
    case "RESERVATION_FAILURE":
      return immer(state, (draft) => {
        draft.error = true;
      });
    case "LOGIN_START":
      return immer(state, (draft) => {
        draft.loading = true;
      });
    case "LOGIN_SUCCESS":
      return immer(state, (draft) => {
        draft.loading = false;
        draft.user = action.payload;
      });
    case "LOGIN_SUCCESS_TOKEN":
      return immer(state, (draft) => {
        draft.token = action.payload;
      });
    case "LOGOUT":
      return immer(state, (draft) => {
        draft.user = null;
      });
    default:
      return state;
  }
};

export default Reducer;
